if (!window.Eurus.loadedScript.has('wf-cart-message-card.js')) {
  window.Eurus.loadedScript.add('wf-cart-message-card.js');

  const SKIP_STORAGE_KEY = 'wf-cart-message-card-skip:v1';
  // Line-item property KEY must match the calendar-worker print/Detrack contract
  // (messageCard.ts BASE_NAMES + "<base> N of M" slot suffix). The customer-facing
  // UI label stays "Message card" (sections.cart.message_card.* translations); only
  // the stored property name changes so the worker can extract + print each slot.
  const MESSAGE_BASE = 'Personal Message (Dear... From...)';
  const SKIP_PROPERTY_PREFIX = '_personal_message_skip';
  const DIGITAL_CLAIM_PREFIX = '_wf_digital_card_claim';
  const DIGITAL_TYPE_PREFIX = '_wf_digital_card_type';
  const LOGO_BASE = 'Company Logo';
  const LOGO_REMOVED_PROPERTY = '_wf_company_logo_removed';
  const LOGO_UPLOAD_URL = 'https://planners.dand3.com/api/message-card-logo';
  const LOGO_MAX_BYTES = 2 * 1024 * 1024;

  function skipPropertyKey(index) {
    return `${SKIP_PROPERTY_PREFIX} ${index}`;
  }

  function digitalClaimPropertyKey(index) {
    return `${DIGITAL_CLAIM_PREFIX} ${index}`;
  }

  function digitalTypePropertyKey(index) {
    return `${DIGITAL_TYPE_PREFIX} ${index}`;
  }

  function logoPropertyKey(index, quantity) {
    return quantity > 1 ? `${LOGO_BASE} ${index} of ${quantity}` : LOGO_BASE;
  }

  // qty 1 -> bare base (legacy single-key path); qty N>1 -> "<base> i of N" slot keys.
  function messagePropertyKey(index, quantity) {
    return quantity > 1 ? `${MESSAGE_BASE} ${index} of ${quantity}` : MESSAGE_BASE;
  }

  function isMessagePropertyKey(key) {
    return key === MESSAGE_BASE || (key.indexOf(`${MESSAGE_BASE} `) === 0 && / \d+ of \d+$/.test(key));
  }

  function normalizeText(value) {
    return String(value == null ? '' : value).trim();
  }

  // Shopify recalculates a line item's key whenever its properties change, so a
  // key captured at render goes stale after the first save. cart/change.js
  // returns the full updated cart; locate our line in it by matching every
  // property we just wrote (the message text is unique), so the caller can
  // refresh its cached key for the next write. Returns the fresh key or null.
  function freshLineKeyFromCart(cart, writtenProperties) {
    if (!cart || !Array.isArray(cart.items)) return null;
    const keys = Object.keys(writtenProperties || {});
    const matches = cart.items.filter((item) => {
      const props = item && item.properties;
      if (!props || typeof props !== 'object') return false;
      return Object.keys(props).length === keys.length && keys.every(
        (k) => normalizeText(props[k]) === normalizeText(writtenProperties[k])
      );
    });
    return matches.length === 1 && matches[0].key ? matches[0].key : null;
  }

  function readSkipMap() {
    try {
      const parsed = JSON.parse(sessionStorage.getItem(SKIP_STORAGE_KEY) || '{}');
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch {
      return {};
    }
  }

  function writeSkipMap(next) {
    try {
      sessionStorage.setItem(SKIP_STORAGE_KEY, JSON.stringify(next && typeof next === 'object' ? next : {}));
    } catch {}
  }

  function slotStorageId(lineKey, index) {
    return `${lineKey}:${index}`;
  }

  function resizeTextarea(el) {
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = `${el.scrollHeight}px`;
  }

  function showCartToast(message) {
    try {
      if (typeof window.WF_LD_SHOW_TOAST === 'function') window.WF_LD_SHOW_TOAST(message);
    } catch {}
  }

  // Delivery-management "Message Card" config from the public worker payload,
  // passed in via initMessageCards(). Controls whether the editor is shown at
  // all (`enabled`) and which products/variants opt out (`excludedProductIds`
  // / `excludedVariantIds`). Cards are server-rendered for every eligible line;
  // this config hides the ones the dashboard says should not show a card.
  // Default: enabled (so a missing/failed config never blanks live carts).
  var messageCardConfig = {
    enabled: true,
    excludedProductIds: {},
    excludedVariantIds: {},
    digitalMedia: { enabled: false, priceLabel: '$7.90', claimApiBase: '', variantId: '' },
  };
  var digitalCartValidation = { required: false, ready: true, ok: true, message: '' };
  var cartMutationTail = Promise.resolve();

  function serializeCartMutation(task) {
    var current = cartMutationTail.then(task, task);
    cartMutationTail = current.catch(function () {});
    return current;
  }

  // Match the worker/theme id contract: GID, prefixed, or bare numeric all
  // collapse to the trailing numeric id (mirrors DOMAIN.normalizeShopifyNumericId).
  function normalizeId(value) {
    var raw = String(value == null ? '' : value).trim();
    if (!raw) return '';
    var gid = raw.match(/\/(\d+)$/);
    if (gid && gid[1]) return gid[1];
    var num = raw.match(/(\d+)/);
    if (num && num[1]) return num[1];
    return raw;
  }

  function toIdSet(list) {
    var set = {};
    if (Array.isArray(list)) {
      list.forEach(function (id) {
        var norm = normalizeId(id);
        if (norm) set[norm] = true;
      });
    }
    return set;
  }

  function setRootHidden(root, hidden) {
    if (hidden) {
      root.setAttribute('data-wf-msg-hidden', 'true');
      root.style.display = 'none';
    } else {
      root.removeAttribute('data-wf-msg-hidden');
      root.style.display = '';
    }
  }

  function getAllMessageCardRoots() {
    return document.querySelectorAll('.wf-cart-message-cards');
  }

  // Active = visible per config. Every checkout-gating / save consumer reads
  // this, so a config-hidden card never blocks checkout or gets saved.
  function getMessageCardsRoot() {
    return Array.prototype.filter.call(getAllMessageCardRoots(), function (root) {
      return root.getAttribute('data-wf-msg-hidden') !== 'true';
    });
  }

  // Show/hide each server-rendered editor against the dashboard config. Runs on
  // initMessageCards() and again after every silent cart refresh (the section
  // innerHTML swap re-renders fresh, un-hidden card nodes).
  function applyMessageCardConfig() {
    var enabled = messageCardConfig.enabled !== false;
    var excludedProducts = messageCardConfig.excludedProductIds || {};
    var excludedVariants = messageCardConfig.excludedVariantIds || {};
    Array.prototype.forEach.call(getAllMessageCardRoots(), function (root) {
      var productId = normalizeId(root.getAttribute('data-product-id'));
      var variantId = normalizeId(root.getAttribute('data-variant-id'));
      var hide =
        !enabled ||
        (productId && excludedProducts[productId]) ||
        (variantId && excludedVariants[variantId]);
      setRootHidden(root, !!hide);
    });
  }

  function digitalVariantId() {
    var media = messageCardConfig.digitalMedia || {};
    return normalizeId(media.variantId);
  }

  function digitalMediaConfigured() {
    var media = messageCardConfig.digitalMedia || {};
    return media.enabled === true && !!digitalVariantId();
  }

  function isFlowerStandProductType(value) {
    return normalizeText(value) === 'Flower Stands';
  }

  function productTypeForCartItem(item) {
    var direct = normalizeText(item && item.product_type);
    if (direct) return direct;
    var productId = normalizeId(item && item.product_id);
    if (!productId) return '';
    var roots = getAllMessageCardRoots();
    for (var index = 0; index < roots.length; index += 1) {
      if (normalizeId(roots[index].getAttribute('data-product-id')) === productId) {
        return normalizeText(roots[index].getAttribute('data-product-type'));
      }
    }
    return '';
  }

  function readCartProperties(item) {
    return item && item.properties && typeof item.properties === 'object' ? item.properties : {};
  }

  function renderedDigitalClaimsPresent() {
    if (document.querySelector('[data-wf-digital-card-fee="true"]')) return true;
    return Array.prototype.some.call(getAllMessageCardRoots(), function (root) {
      var props = parseProperties(root.getAttribute('data-properties'));
      return Object.keys(props).some(function (key) {
        return key.indexOf(`${DIGITAL_CLAIM_PREFIX} `) === 0;
      });
    });
  }

  function cartHasForbiddenFlowerStandClaim(cart) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    return items.some(function (item) {
      if (!isFlowerStandProductType(productTypeForCartItem(item))) return false;
      return Object.keys(readCartProperties(item)).some(function (key) {
        return key.indexOf(`${DIGITAL_CLAIM_PREFIX} `) === 0;
      });
    });
  }

  function validateDigitalCardCart(cart) {
    if (cartHasForbiddenFlowerStandClaim(cart)) {
      return {
        ok: false,
        message: 'Digital messages are not available for Flower Stands. Please remove the add-on before checkout.',
      };
    }
    if (!digitalMediaConfigured()) {
      var staleDigitalItem = (cart && Array.isArray(cart.items) ? cart.items : []).some(function (item) {
        var props = readCartProperties(item);
        return normalizeText(props._wf_digital_card_fee) === 'yes'
          || Object.keys(props).some(function (key) { return key.indexOf(`${DIGITAL_CLAIM_PREFIX} `) === 0; });
      });
      return staleDigitalItem
        ? { ok: false, message: 'Please remove the digital message add-on before checkout.' }
        : { ok: true, message: '' };
    }
    var feeVariantId = digitalVariantId();
    var sourceClaims = {};
    var feeClaims = {};
    var invalid = false;
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    items.forEach(function (item) {
      var variantId = normalizeId(item && item.variant_id);
      var props = readCartProperties(item);
      var isFee = variantId === feeVariantId;
      if (isFee) {
        var feeClaim = normalizeText(props[DIGITAL_CLAIM_PREFIX]);
        var expectedType = 'bundle';
        var feeSlot = parseInt(props._wf_digital_card_slot, 10);
        var feeTotal = parseInt(props._wf_digital_card_total, 10);
        if (!feeClaim || Number(item.quantity || 0) !== 1 || normalizeText(props[DIGITAL_TYPE_PREFIX]) !== expectedType || !Number.isFinite(feeSlot) || !Number.isFinite(feeTotal) || feeTotal < feeSlot || feeClaims[feeClaim]) {
          invalid = true;
          return;
        }
        feeClaims[feeClaim] = { type: expectedType, slotIndex: feeSlot, slotTotal: feeTotal };
        return;
      }
      Object.keys(props).forEach(function (key) {
        if (key.indexOf(`${DIGITAL_CLAIM_PREFIX} `) !== 0) return;
        var slotIndex = parseInt(key.slice(DIGITAL_CLAIM_PREFIX.length + 1), 10);
        var claim = normalizeText(props[key]);
        var type = normalizeText(props[digitalTypePropertyKey(slotIndex)]);
        if (!claim || !Number.isFinite(slotIndex) || slotIndex < 1 || slotIndex > Number(item.quantity || 1) || type !== 'bundle' || sourceClaims[claim]) {
          invalid = true;
          return;
        }
        sourceClaims[claim] = { type, slotIndex, slotTotal: Number(item.quantity || 1) };
      });
    });
    var sourceKeys = Object.keys(sourceClaims);
    var feeKeys = Object.keys(feeClaims);
    if (invalid || sourceKeys.length !== feeKeys.length || sourceKeys.some(function (claim) {
      var fee = feeClaims[claim];
      var source = sourceClaims[claim];
      return !fee || fee.type !== source.type || fee.slotIndex !== source.slotIndex;
    })) {
      return { ok: false, message: 'Please remove and add the digital message again before checkout.' };
    }
    return { ok: true, message: '' };
  }

  function reconcileDigitalCardCart() {
    var required = digitalMediaConfigured() || renderedDigitalClaimsPresent();
    digitalCartValidation = { required: required, ready: !required, ok: !required, message: '' };
    if (!required) return Promise.resolve(digitalCartValidation);
    return fetch(`${Shopify.routes.root}cart.js`, { credentials: 'same-origin', cache: 'no-store' })
      .then(function (response) { return response.ok ? response.json() : Promise.reject(new Error('cart read failed')); })
      .then(function (cart) {
        var result = validateDigitalCardCart(cart);
        digitalCartValidation = { required: true, ready: true, ok: result.ok, message: result.message };
        return digitalCartValidation;
      })
      .catch(function () {
        digitalCartValidation = {
          required: true,
          ready: false,
          ok: false,
          message: 'We could not confirm your digital message. Please try again.',
        };
        return digitalCartValidation;
      });
  }

  function getSlotElements(root) {
    return root ? root.querySelectorAll('[data-wf-msg-slot]') : [];
  }

  function parseProperties(raw) {
    if (!raw) return {};
    try {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) {
        const obj = {};
        parsed.forEach((pair) => {
          if (Array.isArray(pair) && pair.length >= 2) obj[String(pair[0])] = pair[1];
        });
        return obj;
      }
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch {
      return {};
    }
  }

  function getAlpineComponent(el) {
    if (!el || typeof Alpine === 'undefined' || typeof Alpine.$data !== 'function') return null;
    try {
      return Alpine.$data(el);
    } catch {
      return null;
    }
  }

  function collectBlockingState() {
    const blocking = [];
    const logoUploads = [];

    if (digitalCartValidation.required && (!digitalCartValidation.ready || !digitalCartValidation.ok)) {
      blocking.push({
        focusSlot: function () {
          var first = getMessageCardsRoot()[0];
          if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
        },
      });
    }

    getMessageCardsRoot().forEach((root) => {
      const component = getAlpineComponent(root);
      if (!component) return;
      if (typeof component.getLogoUploadBlockers === 'function') {
        logoUploads.push(...component.getLogoUploadBlockers());
      }
      if (typeof component.getBlockingSlots === 'function') {
        blocking.push(...component.getBlockingSlots());
      }
    });

    if (logoUploads.length) {
      return {
        ok: false,
        message: 'Please wait for your company logo to finish uploading before checkout.',
        blocking: logoUploads,
      };
    }

    if (!blocking.length) {
      return { ok: true, message: '' };
    }

    return {
      ok: false,
      message: digitalCartValidation.required && (!digitalCartValidation.ready || !digitalCartValidation.ok)
        ? (digitalCartValidation.message || 'Please confirm your digital message before checkout.')
        :
        blocking.length > 1
          ? 'Before checkout, please save a message for each arrangement or choose “No message needed”.'
          : 'Before checkout, please save your message or choose “No message needed”.',
      blocking,
    };
  }

  function promptFirstBlocker(state) {
    const first = state.blocking && state.blocking[0];
    if (!first || typeof first.focusSlot !== 'function') return;
    first.focusSlot();
  }

  function prepareMessagesForCheckout() {
    const state = collectBlockingState();
    if (!state.ok) {
      promptFirstBlocker(state);
      return Promise.resolve(state);
    }

    const saves = [];
    getMessageCardsRoot().forEach((root) => {
      const component = getAlpineComponent(root);
      if (component && typeof component.saveDirtySlots === 'function') {
        saves.push(component.saveDirtySlots(true));
      }
    });

    if (!saves.length) return Promise.resolve({ ok: true, message: '' });

    return Promise.all(saves).then((results) => {
      const failed = results.some((result) => result === false);
      if (failed) {
        return {
          ok: false,
          message: 'We could not save one of your messages. Please try again.',
        };
      }
      return { ok: true, message: '' };
    });
  }

  window.WF_CART_LINE_MESSAGES = {
    initMessageCards(config) {
      if (config && typeof config === 'object') {
        messageCardConfig = {
          // Treat only an explicit `false` as disabled; a missing flag keeps
          // cards visible so a config gap never blanks the live cart.
          enabled: config.enabled !== false,
          excludedProductIds: toIdSet(config.excludedProductIds),
          excludedVariantIds: toIdSet(config.excludedVariantIds),
          digitalMedia: config.digitalMedia && typeof config.digitalMedia === 'object'
            ? {
                enabled: config.digitalMedia.enabled === true,
                priceLabel: normalizeText(config.digitalMedia.priceLabel) || '$7.90',
                claimApiBase: normalizeText(config.digitalMedia.claimApiBase).replace(/\/+$/, ''),
                variantId: normalizeId(config.digitalMedia.variantId || config.digitalMedia.photoVariantId),
              }
            : { enabled: false, priceLabel: '$7.90', claimApiBase: '', variantId: '' },
        };
      }
      applyMessageCardConfig();
      getAllMessageCardRoots().forEach((root) => {
        const component = getAlpineComponent(root);
        if (component) component.digitalMediaConfigVersion = Number(component.digitalMediaConfigVersion || 0) + 1;
      });
      reconcileDigitalCardCart();
    },
    prepareMessagesForCheckout,
    saveAllUnsavedMessages: prepareMessagesForCheckout,
    getCheckoutBlockingState: collectBlockingState,
    validateDigitalCardCart,
    reconcileDigitalCardCart,
  };

  // A silent cart refresh (qty stepper, message save, discount apply) swaps the
  // cart section innerHTML, re-rendering fresh card nodes with no hidden state.
  // Re-apply the cached config so excluded / disabled products stay hidden.
  document.addEventListener('wf:cart:refreshed', function () {
    applyMessageCardConfig();
    reconcileDigitalCardCart();
  });

  // Surface a one-line notice near the checkout button when a message card is
  // unresolved. Reuses the delivery form's #wf-ld-checkout-hint when present so
  // the copy sits with the other pre-checkout hints.
  function showCheckoutBlockingLiner(message) {
    const hint = document.getElementById('wf-ld-checkout-hint');
    if (!hint) return;
    hint.textContent =
      message || 'Before checkout, please save your message or choose “No message needed”.';
    hint.style.display = 'block';
  }

  // Gate the VISIBLE Eurus checkout button (#checkout-submit) the same way the
  // theme's own validators do (cart-term.js / cart-fields.js): the button's
  // @click runs goToCheckout(), which calls validateCart(true) and dispatches
  // "eurus:cart:validate" synchronously, then proceeds only if validated stays
  // true. A pending message-card slot must therefore flip validated=false here,
  // or the customer can check out having silently skipped their card message.
  // On an actual checkout attempt (isCheckOut) we also push a liner and scroll
  // back to the first unresolved card so they know to type+save or decline.
  document.addEventListener('eurus:cart:validate', (e) => {
    const state = collectBlockingState();
    if (state.ok) return;
    try {
      // Eurus does not put Alpine on window — access it bare, exactly like the
      // theme's own validators (cart-term.js / cart-fields.js) and getAlpineComponent.
      const helper = typeof Alpine !== 'undefined' && typeof Alpine.store === 'function' ? Alpine.store('xCartHelper') : null;
      if (helper) helper.validated = false;
    } catch {}
    if (e && e.detail && e.detail.isCheckOut) {
      showCheckoutBlockingLiner(state.message);
      promptFirstBlocker(state);
    }
  });

  function registerCartMessageCard() {
    if (window.__wfCartMessageCardRegistered) return;
    window.__wfCartMessageCardRegistered = true;

    Alpine.data('xCartMessageCard', (line, quantity, lineKey) => ({
        line,
        quantity,
        lineKey,
        saving: false,
        digitalMediaConfigVersion: 0,
        slots: [],

        init() {
          const props = this.getProperties();
          const skipMap = readSkipMap();

          this.slots = Array.from({ length: this.quantity }, (_, idx) => {
            const index = idx + 1;
            const key = messagePropertyKey(index, this.quantity);
            const logoKey = logoPropertyKey(index, this.quantity);
            const skipKey = skipPropertyKey(index);
            const skippedOnCart = normalizeText(props[skipKey]).toLowerCase() === 'yes';
            const skippedInSession = !!skipMap[slotStorageId(this.lineKey, index)];
            const skipped = skippedOnCart || skippedInSession;
            let savedValue = normalizeText(props[key]);
            const digitalMediaClaim = normalizeText(props[digitalClaimPropertyKey(index)]);
            const digitalMediaType = normalizeText(props[digitalTypePropertyKey(index)]);

            if (skipped) savedValue = '';

            let status = 'pending';
            if (savedValue) status = 'saved';
            else if (skipped) status = 'declined';

            return {
              index,
              key,
              logoKey,
              logoUrl: normalizeText(props[logoKey]),
              logoPreviewUrl: '',
              logoUploading: false,
              logoStatusMessage: '',
              logoStatusError: false,
              draft: savedValue,
              savedValue,
              status,
              statusMessage: '',
              statusError: false,
              digitalMediaClaim,
              digitalMediaType: digitalMediaClaim && digitalMediaType === 'bundle' ? digitalMediaType : '',
              digitalMediaBusy: false,
              digitalMediaStatus: '',
              digitalMediaError: false,
            };
          });
          this.cleanupOutOfRangeDigitalMedia(props);
        },

        componentRoot() {
          if (this.$root?.getAttribute?.('data-product-id')) return this.$root;
          return this.$el?.closest?.('.wf-cart-message-cards') || this.$root;
        },

        getProperties() {
          const raw = this.componentRoot().getAttribute('data-properties');
          return parseProperties(raw);
        },

        async getLiveProperties() {
          const response = await fetch(`${Shopify.routes.root}cart.js`, {
            credentials: 'same-origin',
            cache: 'no-store',
          });
          if (!response.ok) throw new Error('Cart read failed');
          const cart = await response.json();
          const items = Array.isArray(cart.items) ? cart.items : [];
          let lineItem = items.find((item) => normalizeText(item.key) === normalizeText(this.lineKey));
          if (!lineItem) {
            const root = this.componentRoot();
            const productId = normalizeId(root.getAttribute('data-product-id'));
            const variantId = normalizeId(root.getAttribute('data-variant-id'));
            const candidates = items.filter((item) => (
              normalizeId(item.product_id) === productId && normalizeId(item.variant_id) === variantId
            ));
            if (candidates.length !== 1) throw new Error('Cart line could not be identified');
            lineItem = candidates[0];
          }
          if (lineItem.key) this.lineKey = lineItem.key;
          return { ...readCartProperties(lineItem) };
        },

        setProperties(properties) {
          this.componentRoot().setAttribute('data-properties', JSON.stringify(properties));
        },

        getCurrentQuantity() {
          const cartItem = this.componentRoot().closest('.cart-item');
          const input = cartItem?.querySelector('input[type="number"]');
          const parsed = parseInt(input?.value, 10);
          return Number.isFinite(parsed) && parsed > 0 ? parsed : this.quantity;
        },

        getSlot(index) {
          return this.slots.find((slot) => slot.index === index);
        },

        productType() {
          return normalizeText(this.componentRoot().getAttribute('data-product-type'));
        },

        logoUploadUrl() {
          return normalizeText(this.componentRoot().getAttribute('data-logo-upload-url')) || LOGO_UPLOAD_URL;
        },

        freshLineKey(cart, writtenProperties) {
          const exactKey = freshLineKeyFromCart(cart, writtenProperties);
          if (exactKey) return exactKey;
          const root = this.componentRoot();
          const productId = normalizeId(root.getAttribute('data-product-id'));
          const variantId = normalizeId(root.getAttribute('data-variant-id'));
          const matches = (Array.isArray(cart?.items) ? cart.items : []).filter((item) => (
            normalizeId(item.product_id) === productId && normalizeId(item.variant_id) === variantId
          ));
          return matches.length === 1 ? matches[0].key : null;
        },

        isBusy() {
          return this.saving || this.isLogoUploading() || this.isDigitalMediaBusy();
        },

        isLogoUploading() {
          return this.slots.some((slot) => slot.logoUploading);
        },

        isDigitalMediaBusy() {
          return this.slots.some((slot) => slot.digitalMediaBusy);
        },

        hasDraft(index) {
          const slot = this.getSlot(index);
          return !!slot && normalizeText(slot.draft).length > 0;
        },

        slotLabel(index) {
          return this.quantity > 1 ? `${index} / ${this.quantity}` : '';
        },

        digitalMediaEnabled() {
          this.digitalMediaConfigVersion;
          return digitalMediaConfigured() && !isFlowerStandProductType(this.productType());
        },

        digitalMediaPrice() {
          return normalizeText(messageCardConfig.digitalMedia?.priceLabel) || '$7.90';
        },

        digitalMediaLabel(index) {
          return this.getSlot(index)?.digitalMediaType ? 'Digital message added' : '';
        },

        setDigitalMediaStatus(slot, message, isError) {
          slot.digitalMediaStatus = message || '';
          slot.digitalMediaError = !!isError;
        },

        setLogoStatus(slot, message, isError) {
          slot.logoStatusMessage = message || '';
          slot.logoStatusError = !!isError;
        },

        clearLogoPreview(slot) {
          if (!slot?.logoPreviewUrl) return;
          try {
            if (window.URL && typeof window.URL.revokeObjectURL === 'function') {
              window.URL.revokeObjectURL(slot.logoPreviewUrl);
            }
          } catch {}
          slot.logoPreviewUrl = '';
        },

        showLogoPreview(slot, file) {
          this.clearLogoPreview(slot);
          try {
            if (window.URL && typeof window.URL.createObjectURL === 'function') {
              slot.logoPreviewUrl = window.URL.createObjectURL(file);
            }
          } catch {}
        },

        async writeLogoProperty(slot, url) {
          const properties = await this.getLiveProperties();
          if (url) {
            properties[slot.logoKey] = url;
            delete properties[LOGO_REMOVED_PROPERTY];
          } else {
            delete properties[slot.logoKey];
            // Shopify ignores an empty properties object once a cart line has
            // properties. Keep one private marker so a logo-only line can be
            // rewritten without removing and re-adding the product.
            if (Object.keys(properties).length === 0) properties[LOGO_REMOVED_PROPERTY] = 'yes';
          }

          await Alpine.store('xCartHelper').waitForCartUpdate();
          const response = await fetch(`${Shopify.routes.root}cart/change.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              id: this.lineKey,
              quantity: this.getCurrentQuantity(),
              properties,
            }),
          });
          const data = await response.json();
          if (!response.ok || data.status === 422) throw new Error('Cart update failed');

          const refreshedKey = freshLineKeyFromCart(data, properties);
          if (!refreshedKey) throw new Error('Updated cart line was not found');
          this.lineKey = refreshedKey;
          this.applyPropertiesLocally(properties);
          slot.logoUrl = url;
        },

        async uploadLogo(index, event) {
          const slot = this.getSlot(index);
          const input = event?.target;
          const file = input?.files?.[0];
          const busy = this.isBusy();
          const flowerStand = isFlowerStandProductType(this.productType());
          if (!slot || !file || busy || !flowerStand) return false;
          this.setLogoStatus(slot, '', false);

          if (!['image/png', 'image/jpeg'].includes(file.type) || file.size > LOGO_MAX_BYTES) {
            input.value = '';
            this.setLogoStatus(slot, 'Please choose a PNG or JPEG logo up to 2 MB.', true);
            return false;
          }

          this.showLogoPreview(slot, file);
          slot.logoUploading = true;
          this.setLogoStatus(slot, 'Uploading and processing your logo…', false);
          showCartToast('Uploading corporate logo…');
          try {
            const form = new FormData();
            form.append('logo', file);
            form.append('productId', this.componentRoot().getAttribute('data-product-id') || '');
            const response = await fetch(this.logoUploadUrl(), { method: 'POST', body: form });
            const result = await response.json().catch(() => ({}));
            if (!response.ok || !result.url) {
              throw new Error(result.error || 'We could not upload your logo. Please try again.');
            }
            this.setLogoStatus(slot, 'Saving logo to your cart…', false);
            this.saving = true;
            await serializeCartMutation(() => this.writeLogoProperty(slot, result.url));
            if (result.preview !== true) this.clearLogoPreview(slot);
            this.setLogoStatus(slot, 'Logo attached.', false);
            showCartToast('Corporate logo added to your card.');
            return true;
          } catch (error) {
            this.clearLogoPreview(slot);
            const message = error instanceof Error ? error.message : 'We could not upload your logo. Please try again.';
            this.setLogoStatus(slot, message, true);
            showCartToast(message);
            return false;
          } finally {
            input.value = '';
            this.saving = false;
            slot.logoUploading = false;
          }
        },

        async removeLogo(index) {
          const slot = this.getSlot(index);
          if (!slot || !slot.logoUrl || this.isBusy() || !isFlowerStandProductType(this.productType())) return false;
          slot.logoUploading = true;
          this.saving = true;
          this.clearLogoPreview(slot);
          this.setLogoStatus(slot, '', false);
          showCartToast('Removing corporate logo…');
          try {
            await serializeCartMutation(() => this.writeLogoProperty(slot, ''));
            this.setLogoStatus(slot, 'Logo removed.', false);
            showCartToast('Corporate logo removed.');
            return true;
          } catch {
            this.setLogoStatus(slot, 'We could not remove your logo. Please try again.', true);
            showCartToast('We could not remove your logo. Please try again.');
            return false;
          } finally {
            this.saving = false;
            slot.logoUploading = false;
          }
        },

        async removeFeeLineByClaim(claim) {
          if (!claim) return;
          const cartResponse = await fetch(`${Shopify.routes.root}cart.js`, {
            credentials: 'same-origin',
            cache: 'no-store',
          });
          if (!cartResponse.ok) throw new Error('cart read failed');
          const cart = await cartResponse.json();
          const fee = (cart.items || []).find((item) => {
            const props = readCartProperties(item);
            return normalizeText(props[DIGITAL_CLAIM_PREFIX]) === claim &&
              digitalVariantId() === normalizeId(item.variant_id);
          });
          if (!fee) return;
          const response = await fetch(`${Shopify.routes.root}cart/change.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: fee.key, quantity: 0 }),
          });
          if (!response.ok) throw new Error('fee removal failed');
        },

        async writeDigitalSourceProperties(index, claim, type) {
          const properties = await this.getLiveProperties();
          if (claim) {
            properties[digitalClaimPropertyKey(index)] = claim;
            properties[digitalTypePropertyKey(index)] = type;
          } else {
            delete properties[digitalClaimPropertyKey(index)];
            delete properties[digitalTypePropertyKey(index)];
          }
          const response = await fetch(`${Shopify.routes.root}cart/change.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              id: this.lineKey,
              quantity: this.getCurrentQuantity(),
              properties,
            }),
          });
          const cart = await response.json();
          if (!response.ok || cart.status === 422) throw new Error('source update failed');
          const refreshedKey = freshLineKeyFromCart(cart, properties);
          if (refreshedKey) this.lineKey = refreshedKey;
          this.applyPropertiesLocally(properties);
        },

        cleanupOutOfRangeDigitalMedia(properties) {
          const claims = [];
          const slots = new Set();
          Object.keys(properties).forEach((key) => {
            if (!key.startsWith(`${DIGITAL_CLAIM_PREFIX} `) && !key.startsWith(`${DIGITAL_TYPE_PREFIX} `)) return;
            const index = parseInt(key.slice(key.lastIndexOf(' ') + 1), 10);
            if (!Number.isFinite(index) || index <= this.quantity) return;
            slots.add(index);
            if (key.startsWith(`${DIGITAL_CLAIM_PREFIX} `)) {
              const claim = normalizeText(properties[key]);
              if (claim) claims.push(claim);
            }
          });
          if (slots.size === 0) return;
          slots.forEach((index) => {
            delete properties[digitalClaimPropertyKey(index)];
            delete properties[digitalTypePropertyKey(index)];
          });
          serializeCartMutation(async () => {
            await Alpine.store('xCartHelper').waitForCartUpdate();
            for (const claim of claims) await this.removeFeeLineByClaim(claim);
            const nextProperties = await this.getLiveProperties();
            slots.forEach((index) => {
              delete nextProperties[digitalClaimPropertyKey(index)];
              delete nextProperties[digitalTypePropertyKey(index)];
            });
            const response = await fetch(`${Shopify.routes.root}cart/change.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: this.lineKey, quantity: this.getCurrentQuantity(), properties: nextProperties }),
            });
            const cart = await response.json();
            if (!response.ok || cart.status === 422) throw new Error('source cleanup failed');
            const refreshedKey = freshLineKeyFromCart(cart, nextProperties);
            if (refreshedKey) this.lineKey = refreshedKey;
            this.applyPropertiesLocally(nextProperties);
            await reconcileDigitalCardCart();
            await window.WF_LD_EXPRESS_CART?.refreshCartTotals?.();
          }).catch(() => reconcileDigitalCardCart());
        },

        async addDigitalMedia(index) {
          const slot = this.getSlot(index);
          if (!slot || slot.digitalMediaClaim || this.isBusy() || !this.digitalMediaEnabled()) return false;
          const type = 'bundle';
          slot.digitalMediaBusy = true;
          this.setDigitalMediaStatus(slot, 'Adding…', false);
          showCartToast('Adding digital message card…');
          return serializeCartMutation(async () => {
            let addedFeeKey = '';
            try {
              await Alpine.store('xCartHelper').waitForCartUpdate();
              const apiBase = messageCardConfig.digitalMedia?.claimApiBase || window.WF_LD_API?.API_BASE || 'https://planners.dand3.com';
              const claimResponse = await fetch(`${apiBase}/public/digital-cards/claim`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                credentials: 'omit',
                body: JSON.stringify({ mediaType: type }),
              });
              const claimData = await claimResponse.json();
              const claim = normalizeText(claimData.claim);
              if (!claimResponse.ok || !claim) throw new Error('claim failed');

              const feeResponse = await fetch(`${Shopify.routes.root}cart/add.js`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ items: [{
                  id: digitalVariantId(),
                  quantity: 1,
                  properties: {
                    _wf_digital_card_fee: 'yes',
                    _wf_digital_card_claim: claim,
                    _wf_digital_card_type: type,
                    _wf_digital_card_slot: String(index),
                    _wf_digital_card_total: String(this.getCurrentQuantity()),
                    'Digital message': 'Photo + video',
                  },
                }] }),
              });
              const feeData = await feeResponse.json();
              if (!feeResponse.ok) throw new Error('fee add failed');
              addedFeeKey = normalizeText(feeData.items?.[0]?.key);

              await this.writeDigitalSourceProperties(index, claim, type);
              slot.digitalMediaClaim = claim;
              slot.digitalMediaType = type;
              this.setDigitalMediaStatus(slot, 'Added to cart.', false);
              await reconcileDigitalCardCart();
              await window.WF_LD_EXPRESS_CART?.refreshCartTotals?.();
              showCartToast(`Digital message card add-on ${this.digitalMediaPrice()} added to your order.`);
              return true;
            } catch {
              if (addedFeeKey) {
                try {
                  await fetch(`${Shopify.routes.root}cart/change.js`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                    body: JSON.stringify({ id: addedFeeKey, quantity: 0 }),
                  });
                } catch {}
              }
              this.setDigitalMediaStatus(slot, 'Could not add this. Please try again.', true);
              await reconcileDigitalCardCart();
              await window.WF_LD_EXPRESS_CART?.refreshCartTotals?.();
              return false;
            } finally {
              slot.digitalMediaBusy = false;
            }
          });
        },

        async removeDigitalMedia(index) {
          const slot = this.getSlot(index);
          if (!slot || this.isBusy() || !slot.digitalMediaClaim) return false;
          slot.digitalMediaBusy = true;
          this.setDigitalMediaStatus(slot, 'Removing…', false);
          return serializeCartMutation(async () => {
            try {
              await Alpine.store('xCartHelper').waitForCartUpdate();
              await this.removeFeeLineByClaim(slot.digitalMediaClaim);
              await this.writeDigitalSourceProperties(index, '', '');
              slot.digitalMediaClaim = '';
              slot.digitalMediaType = '';
              this.setDigitalMediaStatus(slot, 'Removed.', false);
              await reconcileDigitalCardCart();
              await window.WF_LD_EXPRESS_CART?.refreshCartTotals?.();
              return true;
            } catch {
              this.setDigitalMediaStatus(slot, 'Could not remove this. Please try again.', true);
              await reconcileDigitalCardCart();
              return false;
            } finally {
              slot.digitalMediaBusy = false;
            }
          });
        },

        startWriting(index) {
          const slot = this.getSlot(index);
          if (!slot) return;
          slot.status = 'pending';
          slot.statusMessage = '';
          slot.statusError = false;
          this.clearSkip(index);
          this.clearSkipProperty(index);
          this.focusSlotInput(index);
        },

        focusSlotInput(index) {
          this.$nextTick(() => {
            // lineKey is a Shopify line-item key ("id:hash") — the colon makes a bare
            // #id selector invalid and the thrown SyntaxError kills the whole handler.
            const input = this.componentRoot().querySelector(`#${CSS.escape(`wf-msg-${this.lineKey}-${index}`)}`);
            resizeTextarea(input);
            input?.focus();
          });
        },

        editMessage(index) {
          this.startWriting(index);
        },

        onDraftInput(index, event) {
          const slot = this.getSlot(index);
          if (!slot) return;
          slot.draft = event.target.value;
          slot.statusMessage = '';
          slot.statusError = false;
          resizeTextarea(event.target);
        },

        clearSkip(index) {
          const skipMap = readSkipMap();
          delete skipMap[slotStorageId(this.lineKey, index)];
          writeSkipMap(skipMap);
        },

        markSkipped(index) {
          const skipMap = readSkipMap();
          skipMap[slotStorageId(this.lineKey, index)] = true;
          writeSkipMap(skipMap);
        },

        buildPropertiesForSlot(index, mode, baseProperties) {
          const slot = this.getSlot(index);
          if (!slot) return null;

          const properties = { ...(baseProperties || this.getProperties()) };

          Object.keys(properties).forEach((key) => {
            if (isMessagePropertyKey(key)) delete properties[key];
          });

          this.slots.forEach((entry) => {
            if (entry.index === index) return;
            const value = normalizeText(entry.savedValue);
            if (value) properties[entry.key] = value;
          });

          Object.keys(properties).forEach((key) => {
            if (key.startsWith(`${SKIP_PROPERTY_PREFIX} `)) delete properties[key];
          });

          this.slots.forEach((entry) => {
            if (entry.index === index) return;
            if (entry.status === 'declined') {
              properties[skipPropertyKey(entry.index)] = 'yes';
            }
          });

          if (mode === 'decline') {
            delete properties[slot.key];
            properties[skipPropertyKey(index)] = 'yes';
            return properties;
          }

          const nextValue = normalizeText(slot.draft);
          if (!nextValue) return null;
          properties[slot.key] = nextValue;
          return properties;
        },

        applyPropertiesLocally(properties) {
          this.setProperties(properties);
        },

        async clearSkipProperty(index) {
          const slot = this.getSlot(index);
          if (!slot) return;

          const skipKey = skipPropertyKey(index);
          if (!(skipKey in this.getProperties())) return;
          slot.status = 'pending';

          return serializeCartMutation(async () => {
            await Alpine.store('xCartHelper').waitForCartUpdate();
            try {
              const properties = await this.getLiveProperties();
              delete properties[skipKey];
              const response = await fetch(`${Shopify.routes.root}cart/change.js`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Accept: 'application/json',
                },
                // Target by stable line KEY, not positional line index: the express/
                // delivery-fee product is added between render and this write, which
                // reorders cart positions, so `line` would land on the wrong item.
                body: JSON.stringify({
                  id: this.lineKey,
                  quantity: this.getCurrentQuantity(),
                  properties,
                }),
              });
              const data = await response.json();
              if (data.status === 422) return;
              // Keep the cached line key in sync (see persistSlot): this write also
              // changed the line's properties, recalculating its key.
              const refreshedKey = freshLineKeyFromCart(data, properties);
              if (refreshedKey) this.lineKey = refreshedKey;
              this.applyPropertiesLocally(properties);
            } catch {}
          });
        },

        setSlotStatus(slot, message, isError) {
          slot.statusMessage = message || '';
          slot.statusError = !!isError;
        },

        async persistSlot(index, mode) {
          const slot = this.getSlot(index);
          if (!slot || this.isBusy()) return false;

          const nextValue = mode === 'decline' ? '' : normalizeText(slot.draft);
          if (mode === 'save' && !nextValue) {
            this.setSlotStatus(slot, 'Please write your message, or choose “No message needed”.', true);
            return false;
          }

          const qty = this.getCurrentQuantity();
          this.saving = true;
          return serializeCartMutation(async () => {
            await Alpine.store('xCartHelper').waitForCartUpdate();
            try {
              const properties = this.buildPropertiesForSlot(index, mode, await this.getLiveProperties());
              if (!properties) {
                this.setSlotStatus(slot, 'Please write your message, or choose “No message needed”.', true);
                return false;
              }
              const response = await fetch(`${Shopify.routes.root}cart/change.js`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Accept: 'application/json',
                },
                // Target by stable line KEY, not positional line index: the express/
                // delivery-fee product is added between render and this write, which
                // reorders cart positions, so `line` would land on the wrong item.
                body: JSON.stringify({
                  id: this.lineKey,
                  quantity: qty,
                  properties,
                }),
              });
              const data = await response.json();
              if (data.status === 422) {
                this.setSlotStatus(slot, 'We could not save your message. Please try again.', true);
                return false;
              }

              // Refresh the cached line key from the returned cart: Shopify just
              // changed this line's properties, so its key has been recalculated
              // and the next save must target the new key, not the stale one.
              const refreshedKey = freshLineKeyFromCart(data, properties);
              if (refreshedKey) this.lineKey = refreshedKey;

              this.applyPropertiesLocally(properties);
              slot.savedValue = nextValue;
              slot.draft = nextValue;

              if (mode === 'decline') {
                slot.status = 'declined';
                this.markSkipped(index);
                this.setSlotStatus(slot, '', false);
              } else {
                slot.status = 'saved';
                this.clearSkip(index);
                this.setSlotStatus(slot, 'Message saved.', false);
              }

              return true;
            } catch {
              this.setSlotStatus(slot, 'We could not save your message. Please try again.', true);
              return false;
            } finally {
              this.saving = false;
            }
          });
        },

        saveMessage(index) {
          if (!this.hasDraft(index)) return Promise.resolve(false);
          return this.persistSlot(index, 'save');
        },

        async declineMessage(index) {
          const slot = this.getSlot(index);
          if (!slot) return false;
          slot.draft = '';
          // The written message and the paid digital add-on are independent: a
          // digital-only card still prints with its QR, so declining the written
          // message must not remove the add-on or change the cart total.
          return this.persistSlot(index, 'decline');
        },

        getBlockingSlots() {
          return this.slots
            .filter((slot) => slot.status === 'pending')
            .map((slot) => ({
              focusSlot: () => {
                this.setSlotStatus(
                  slot,
                  'Please save your message or choose “No message needed”.',
                  true
                );
                this.$nextTick(() => {
                  const card = this.componentRoot().querySelector(`[data-wf-msg-slot="${slot.index}"]`);
                  card?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                  this.focusSlotInput(slot.index);
                });
              },
            }));
        },

        getLogoUploadBlockers() {
          return this.slots
            .filter((slot) => slot.logoUploading)
            .map((slot) => ({
              focusSlot: () => {
                this.setLogoStatus(slot, 'Please wait for your logo to finish uploading.', false);
                this.$nextTick(() => {
                  const card = this.componentRoot().querySelector(`[data-wf-msg-slot="${slot.index}"]`);
                  card?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                });
              },
            }));
        },

        async saveDirtySlots(silent) {
          const dirty = this.slots.filter((slot) => {
            if (slot.status !== 'pending' && slot.status !== 'saved') return false;
            return normalizeText(slot.draft) !== normalizeText(slot.savedValue);
          });

          if (!dirty.length) return true;

          for (const slot of dirty) {
            if (!normalizeText(slot.draft)) continue;
            if (!await this.persistSlot(slot.index, 'save')) return false;
          }
          return true;
        },
      }));
  }

  if (window.Alpine && typeof window.Alpine.data === 'function') {
    registerCartMessageCard();
  }
  document.addEventListener('alpine:init', registerCartMessageCard);
}
